var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"loading"},[_c('loading')],1):_c('pie-chart',{attrs:{"width":"auto","height":"300px","series-data":_vm.series,"tooltip-formater":_vm.tooltipRender,"tooltip-class":"order-pie-tooltip"}})}
var staticRenderFns = []

export { render, staticRenderFns }